/* eslint-disable no-fallthrough */
/* eslint-disable no-unused-vars */
// @flow

import EventEmitter from 'events';
import * as PaymentMethodActionTypes from 'action_types/PaymentMethodActionTypes';
import Dispatcher from 'dispatcher';
import PaymentMethod from 'models/PaymentMethod';

const CHANGE = 'change';
const PAY_ERROR_CHANGE = 'payment_error_change';

let _paymentMethod = [];
let _payment = null;
let _paymentSrPago = {};
let _paymentAdvance = {};
let _errorPaymentSrPago = null;
let _errorPaymentApp = null;
let _errorPaymentAdvance = null;
let _paymentMethodsPhotoshooting = [];
let _paymentPhotoShooting = {};
let _paymentErrorPhotoShooting = {};
let _conektaKey = null;

class PaymentMethodStore extends EventEmitter {
  constructor(): void {
    super();
    Dispatcher.register(this._actionsHandler);
  }

  getPaymentMethodByModel = (model_name: string): any => {
    return _paymentMethod;
  };

  getPaymentMethodsPhotoshooting() {
    return _paymentMethodsPhotoshooting;
  }

  getPaymentPhotoshooting = () => {
    return _paymentPhotoShooting;
  };

  getErrorPaymentPhotoshooting = () => {
    return _paymentErrorPhotoShooting;
  };

  payApplicationByMethod = (): any => {
    return _payment;
  };

  payByMethodSrPago = (): any => {
    return _paymentSrPago;
  };

  errorPayByMethodSrPago = (): any => {
    return _errorPaymentSrPago;
  };

  payByMethodAdvance = (): any => {
    return _paymentAdvance;
  };

  errorPayByMethodAdvance = (): any => {
    return _errorPaymentAdvance;
  };

  errorPayByMethodApp = (): any => {
    return _errorPaymentApp;
  };

  addChangeListener = (callback: () => void) => {
    this.on(CHANGE, callback);
  };

  removeChangeListener = (callback: () => void) => {
    this.removeListener(CHANGE, callback);
  };

  _emitChange = () => {
    this.emit(CHANGE);
  };

  _emitChangeErrorPayment = () => {
    this.emit(PAY_ERROR_CHANGE);
  };

  _setPaymentMethod = (paymentMethod: PaymentMethod) => {
    _paymentMethod = paymentMethod;
  };

  _setPaymentMethodPhotoshooting = (
    paymentMethodPhotoshooting: PaymentMethod
  ) => {
    _paymentMethodsPhotoshooting = paymentMethodPhotoshooting;
  };

  _setPaymentPhotoShooting = (paymentPhotoShooting: any) => {
    _paymentPhotoShooting = paymentPhotoShooting;
  };

  _setErrorPaymentPhoneShooting = (paymentErrorPhotoShooting: any) => {
    _paymentErrorPhotoShooting = paymentErrorPhotoShooting;
  };

  _setPayment = (payment: any) => {
    _payment = payment;
  };

  _setPaymentSrPago = (paymentSrPago: any) => {
    _paymentSrPago = paymentSrPago;
  };

  _setErrorPaymentSrPago = (errorPaymentSrPago: any) => {
    _errorPaymentSrPago = errorPaymentSrPago;
  };

  _setPaymentAdvance = (paymentAdvance: any) => {
    _paymentAdvance = paymentAdvance;
  };

  _setErrorPaymentAdvance = (errorPaymentAdvance: any) => {
    _errorPaymentAdvance = errorPaymentAdvance;
  };

  _setErrorPaymentApp = (errorPaymentApp: any) => {
    _errorPaymentApp = errorPaymentApp;
  };

  _setConektaKey = (conektaKey: any) => {
    _conektaKey = conektaKey;
  };

  getConektaKey = (): any => {
    return _conektaKey;
  };

  flushPaymentData = () => {
    _payment = null;
  };

  flushError = () => {
    _errorPaymentSrPago = null;
    _errorPaymentAdvance = null;
    _errorPaymentApp = null;
  };

  _actionsHandler = (action: any) => {
    switch (action.type) {
      case PaymentMethodActionTypes.GET_PAYMENT_METHOD_BY_MODEL: {
        this._setPaymentMethod(action.paymentMethod);
        this._emitChange();
        break;
      }
      case PaymentMethodActionTypes.POST_PAY_APPLICATION_BY_METHOD: {
        this._setPayment(action.payment);
        this.payApplicationByMethod();
        this._emitChange();
        break;
      }
      case PaymentMethodActionTypes.POST_PAY_BY_SR_PAGO: {
        this._setPaymentSrPago(action.payment);
        this.payByMethodSrPago();
        this._emitChange();
        break;
      }
      case PaymentMethodActionTypes.PAY_BY_ADVANCE_SUCCESS: {
        this._setPaymentAdvance(action.payment);
        this._emitChange();
        break;
      }
      case PaymentMethodActionTypes.PAY_BY_ADVANCE_ERROR: {
        this._setErrorPaymentAdvance(action.error);
        this._emitChange();
        break;
      }
      case PaymentMethodActionTypes.PAYMENT_METHOD_ERROR: {
        this._setErrorPaymentSrPago(action.error);
        this._emitChangeErrorPayment();
        break;
      }
      case PaymentMethodActionTypes.PAYMENT_METHOD_ERROR_APP: {
        this._setErrorPaymentApp(action.error);
        this.errorPayByMethodApp();
        this._emitChange();
        break;
      }
      case PaymentMethodActionTypes.GET_CONEKTA_KEY: {
        this._setConektaKey(action.key);
        this.getConektaKey();
        this._emitChange();
        break;
      }
      case PaymentMethodActionTypes.GET_PAYMENT_METHODS_FOOTOSHOOTING: {
        this._setPaymentMethodPhotoshooting(action.paymentMethods);
        this._emitChange();
      }
      case PaymentMethodActionTypes.POST_PAY_PHOTOSHOOTING: {
        this._setPaymentPhotoShooting(action.payment);
        this._emitChange();
        break;
      }
      case PaymentMethodActionTypes.PAY_PHOTOSHOOTING_ERROR: {
        this._setErrorPaymentPhoneShooting(action.error);
        this._emitChange();
        break;
      }
      case PaymentMethodActionTypes.PAY_SPEI_ADVANCE_SUCCESS: {
        this._setPayment(action.payment);
        this._emitChange();
        break;
      }
    }
  };
}

export default new PaymentMethodStore();
